/** Gövde / segment tipi */

export type AutomobileBodyType =

  | 'sedan'

  | 'hatchback'

  | 'suv'

  | 'coupe'

  | 'cabrio'

  | 'station'

  | 'minibus'

  | 'kamyonet'

  | 'minivan'

  | 'pickup'

  | 'otobus'

  | 'kamyon'

  | 'tir'

  | 'traktor'

  | 'motosiklet';



export type AutomobileCompanyStatus =
  | 'active'
  | 'defunct'
  | 'merged'
  | 'revived'
  | 'subsidiary'
  | 'unknown';

export type AutomobileVerificationLevel = 'verified' | 'partial' | 'unverified';

export interface AutomobileCompanySource {
  title: string;
  url: string;
}

export interface AutomobileModel {

  /** Temel model adı (Elantra, 3 Serisi, Accent) */
  name: string;

  /** Kart başlığı — nesil/variant/yıl birleşik (örn. Elantra (AD) (2016→)) */
  displayName?: string;

  /** Platform / nesil kodu: E46, AD, CN7, SB, MC… */
  generationCode?: string;

  /** Pazarlama alt adı: Blue, Era… */
  variantLabel?: string;

  yearFrom?: number;

  /** 1–12, örn. 08.2011 */
  yearFromMonth?: number;

  yearTo?: number | null;

  /**
   * Kesin üretim yılları (tek tek). Admin panelden düzenlenebilir.
   * Örn: [1990, 1991, 1992]
   */
  productionYears?: number[];

  bodyType: AutomobileBodyType;

  imageUrl: string;

  /** true = gövde tipine göre stok/placeholder görsel */
  imageGeneric?: boolean;

  /** Kart görseli yatay odak (0–100) */
  imageFocalX?: number;

  /** Kart görseli dikey odak (0–100) */
  imageFocalY?: number;

  /** Kart görseli ölçeği (40–250; 100 = normal) */
  imageZoom?: number;

  description?: string;

  descriptionSource?: string;

}



export interface AutomobileBrand {

  slug: string;

  name: string;

  logoUrl: string;

  /** Logo yatay odak (0–100) */
  logoFocalX?: number;

  /** Logo dikey odak (0–100) */
  logoFocalY?: number;

  /** Logo ölçeği (40–250) */
  logoZoom?: number;

  country?: string;

  description: string;

  founded?: number;

  headquarters?: string;

  website?: string;

  highlights?: string[];

  legalName?: string;

  companyStatus?: AutomobileCompanyStatus;

  parentCompany?: string | null;

  successorBrand?: string | null;

  closedYear?: number | null;

  closureReason?: string | null;

  verificationLevel?: AutomobileVerificationLevel;

  sources?: AutomobileCompanySource[];

  models: AutomobileModel[];

}



export interface AutomobileCatalog {

  generatedAt: string;

  brandCount: number;

  brandsWithModels: number;

  modelCount: number;

  verifiedBrandCount?: number;

  defunctBrandCount?: number;

  brands: AutomobileBrand[];

}



export const AUTOMOBILE_COMPANY_STATUS_LABELS: Record<AutomobileCompanyStatus, string> = {
  active: 'Aktif',
  defunct: 'Kapalı',
  merged: 'Birleşmiş',
  revived: 'Yeniden canlandırılmış',
  subsidiary: 'Alt marka',
  unknown: 'Doğrulanmadı',
};

export const AUTOMOBILE_BODY_TYPE_LABELS: Record<AutomobileBodyType, string> = {

  sedan: 'Sedan',

  hatchback: 'Hatchback',

  suv: 'SUV',

  coupe: 'Coupe',

  cabrio: 'Cabrio',

  station: 'Station',

  minibus: 'Minibüs',

  kamyonet: 'Kamyonet',

  minivan: 'Minivan',

  pickup: 'Pickup',

  otobus: 'Otobüs',

  kamyon: 'Kamyon',

  tir: 'Tır',

  traktor: 'Traktör',

  motosiklet: 'Motosiklet',

};



export const AUTOMOBILE_BODY_TYPE_ORDER: AutomobileBodyType[] = [

  'sedan',

  'hatchback',

  'suv',

  'coupe',

  'cabrio',

  'station',

  'minivan',

  'pickup',

  'kamyonet',

  'minibus',

  'otobus',

  'kamyon',

  'tir',

  'traktor',

  'motosiklet',

];

/** İlk açılışta listede gösterilmez; kullanıcı ilgili filtreyi seçince görünür. */
export const AUTOMOBILE_BODY_TYPES_HIDDEN_BY_DEFAULT: AutomobileBodyType[] = ['traktor', 'motosiklet'];



export { AUTOMOBILE_COUNTRY_NAMES, formatAutomobileCountry } from '../utils/automobileCountry';



export const AUTOMOBILE_BODY_CHIP: Record<AutomobileBodyType, string> = {

  sedan: 'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/30',

  hatchback: 'bg-cyan-500/15 text-cyan-800 dark:text-cyan-300 border-cyan-500/30',

  suv: 'bg-emerald-500/15 text-emerald-800 dark:text-emerald-300 border-emerald-500/30',

  coupe: 'bg-violet-500/15 text-violet-800 dark:text-violet-300 border-violet-500/30',

  cabrio: 'bg-pink-500/15 text-pink-800 dark:text-pink-300 border-pink-500/30',

  station: 'bg-amber-500/15 text-amber-800 dark:text-amber-300 border-amber-500/30',

  minivan: 'bg-indigo-500/15 text-indigo-800 dark:text-indigo-300 border-indigo-500/30',

  pickup: 'bg-orange-500/15 text-orange-800 dark:text-orange-300 border-orange-500/30',

  kamyonet: 'bg-yellow-500/15 text-yellow-900 dark:text-yellow-200 border-yellow-500/30',

  minibus: 'bg-teal-500/15 text-teal-800 dark:text-teal-300 border-teal-500/30',

  otobus: 'bg-sky-500/15 text-sky-800 dark:text-sky-300 border-sky-500/30',

  kamyon: 'bg-stone-500/15 text-stone-800 dark:text-stone-300 border-stone-500/30',

  tir: 'bg-red-500/15 text-red-800 dark:text-red-300 border-red-500/30',

  traktor: 'bg-lime-600/15 text-lime-900 dark:text-lime-300 border-lime-600/35',

  motosiklet: 'bg-fuchsia-500/15 text-fuchsia-900 dark:text-fuchsia-300 border-fuchsia-500/35',

};



/** Liste satırı — yatay dikdörtgen (~3.5:1) */
export const AUTOMOBILE_LOGO_BOX_CLASS =
  'block w-[156px] h-[44px] sm:w-[172px] sm:h-[48px]';


